import { render, staticRenderFns } from "./2c2pSuccessPageComponent.vue?vue&type=template&id=3c2c8511&scoped=true&"
import script from "./2c2pSuccessPageComponent.vue?vue&type=script&lang=js&"
export * from "./2c2pSuccessPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./2c2pSuccessPageComponent.vue?vue&type=style&index=0&id=3c2c8511&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c8511",
  null
  
)

export default component.exports